import styled from 'styled-components';

export const Selectors = styled.div`
  display: flex;
  align-items: center;
  column-gap: 24px;
`;
